var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequests(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.615,
    height: 32.615,
    viewBox: "0 0 32.615 32.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660",
    transform: "translate(19403 -413)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 16.307,
    cy: 16.307,
    r: 16.307,
    transform: "translate(-19403 413)",
    fill: "#4776da"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_163_1_",
    "data-name": "Group 163 (1)",
    transform: "translate(-19394.285 421.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4072",
    "data-name": "Path 4072",
    d: "M13.771,70.042h-.6V69.2a.358.358,0,0,0-.358-.358.362.362,0,0,0-.362.358v.839H1.678V63.454a.591.591,0,0,1,.6-.583H6.107a.362.362,0,0,0,.358-.362.358.358,0,0,0-.358-.358H2.27A1.324,1.324,0,0,0,.949,63.475v6.566H.358A.358.358,0,0,0,0,70.4v2.65a1.324,1.324,0,0,0,.384.932,1.324,1.324,0,0,0,.941.371H12.8a1.326,1.326,0,0,0,1.324-1.324V70.377a.358.358,0,0,0-.358-.335ZM13.4,73.026a.587.587,0,0,1-.605.605H1.324a.587.587,0,0,1-.605-.605v-2.27H13.4Z",
    transform: "translate(0 -60.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4073",
    "data-name": "Path 4073",
    d: "M172.9,369.778h-2.87a.36.36,0,0,0,0,.72h2.87a.36.36,0,0,0,0-.72Z",
    transform: "translate(-164.404 -358.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4074",
    "data-name": "Path 4074",
    d: "M222.633,0h-3.824a1.324,1.324,0,0,0-1.324,1.324V3.8a.358.358,0,1,0,.716,0V1.324a.6.6,0,0,1,.6-.6h3.832a.6.6,0,0,1,.605.6V6.107a.6.6,0,0,1-.605.6h-4.857l.342-.344a.359.359,0,0,0-.508-.508l-.958.953a.362.362,0,0,0-.075.392.349.349,0,0,0,.331.216h5.722A1.324,1.324,0,0,0,223.955,6.1V1.324A1.324,1.324,0,0,0,222.633,0Z",
    transform: "translate(-209.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4075",
    "data-name": "Path 4075",
    d: "M310.759,108.667a.358.358,0,0,0,.358-.358.362.362,0,0,0-.358-.362h-1.917a.36.36,0,1,0,0,.72Z",
    transform: "translate(-298.903 -104.596)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/Requests.fcd185f5c47215ab68dbd33e6c630da6.svg";
export { ForwardRef as ReactComponent };